import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import { mq } from '@sthzg/sthzgnet-base';
import { StripedHeadline } from '../index';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  ${mq.small(css`
    flex-direction: row;
    background: transparent;
  `)};
`;

const List = styled.ul`
  font-family: monospace;
  font-size: 1.1em;
  color: rgb(60, 60, 60);
  line-height: 1.6em;
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
  list-style-type: none;
  ${mq.small(css`
    width: 67%;
    padding-left: 40px;
  `)};
`;

const Item = styled.li`
  margin: 8px 0;
  text-align: center;

  &:first-child {
    margin-top: 0;
    padding-top: 0;
  }
`;

const BaseHeadline = ({ className }) => (
  <StripedHeadline className={className} tokens={'Freelance Web Developer'.split(' ')} />
);
BaseHeadline.propTypes = {
  className: PropTypes.string.isRequired,
};

const Headline = styled(BaseHeadline)`
  text-align: center;
  ${mq.small(css`
    text-align: left;
    width: 33%;
  `)};
`;

const AboutBlock = () => (
  <Wrapper>
    <Headline />
    <List>
      <Item>10+ years a code monkey</Item>
      <Item>40+ commercial projects</Item>
      <Item>Escaping from the Monolith</Item>
      <Item>RESTful unless wired to a socket</Item>
      <Item>Head in the serverless clouds</Item>
      <Item>Friendly and well-behaved</Item>
    </List>
  </Wrapper>
);

export default AboutBlock;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/AboutBlock/AboutBlock.jsx